<template>
  <div class="p-5 flex flex-col">
    <p class="font-semibold text-2xl">
      {{ this.$route.meta.title }}
    </p>
    <!-- FILTER CONTAINER -->
    <vs-row
      vs-w="12"
      class="my-5 filter-container"
    >
      <vs-col vs-w="1">
        <p class="font-semibold">
          Filter
        </p>
      </vs-col>
      <vs-col vs-w="3" />
      <vs-col vs-w="2">
        <select-with-search
          v-model="filters.owner_id"
          placeholder="Owner"
          class="px-2"
          :options="options.owner"
        />
      </vs-col>
      <vs-col vs-w="2">
        <select-with-search
          v-model="filters.route_name"
          placeholder="Route"
          class="px-2"
          :options="options.route"
        />
      </vs-col>
      <vs-col vs-w="1.5">
        <date-picker
          v-model="filters.month"
          :format="'MMM'"
          type="month"
          value-type="M"
          placeholder="Month"
          class="px-2"
        />
      </vs-col>
      <vs-col vs-w="1.5">
        <date-picker
          v-model="filters.year"
          :format="'YYYY'"
          type="year"
          value-type="YYYY"
          placeholder="Year"
          class="px-2"
        />
      </vs-col>
      <vs-col
        vs-w="1"
        class="flex flex-col justify-center"
      >
        <vs-button
          type="border"
          color="primary"
          class="self-center 2xl:self-end font-semibold"
          style="min-width: 100px;"
          @click="resetFilters"
        >
          Reset
        </vs-button>
      </vs-col>
    </vs-row>
    <div class="w-full flex flex-col gap-5 mt-5">
      <!-- MAJOR ASSUMPTION -->
      <div class="flex flex-col gap-2">
        <span class="text-lg font-semibold self-start">
          Major Assumption
        </span>
        <major-assumption 
          :filters="filters"
        />
      </div>
      <!-- LOGISTIC COST PER ACTIVITY -->
      <div class="w-full flex flex-col gap-2">
        <span class="text-lg font-semibold self-start">
          Logistic Cost per Activity
        </span>
        <logistic-cost-per-activity
          :filters="filters" 
        />
      </div>
      <!-- TOTAL LOGISTIC COST -->
      <div class="flex flex-col gap-2">
        <span class="text-lg font-semibold self-start">
          Total Logistic Cost
        </span>
        <total-logistic-cost 
          :filters="filters" 
        />
      </div>
      <!-- BARGE LOGISTIC MONITORING -->
      <div class="flex flex-col gap-2">
        <span class="text-lg font-semibold self-start">
          Barge Logistic Monitoring
        </span>
        <barge-logistic-monitoring 
          :filters="filters" 
        />
      </div>
      <!-- LOGISTIC COST 3RD PARTY COAL -->
      <div class="flex flex-col gap-2">
        <span class="text-lg font-semibold self-start">
          Logistic Cost 3rd Party Coal
        </span>
        <logistic-cost-3rd-party-coal 
          :filters="filters" 
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

import DatePicker from '@/components/datePicker'
import SelectWithSearch from '@/components/selectWithSearch'

import BargeLogisticMonitoring from './components/BargeLogisticMonitoring'
import LogisticCost3rdPartyCoal from './components/LogisticCost3rdPartyCoal'
import LogisticCostPerActivity from './components/LogisticCostPerActivity'
import MajorAssumption from './components/MajorAssumption'
import TotalLogisticCost from './components/TotalLogisticCost'

export default {
  components: {
    SelectWithSearch,
    DatePicker,
    MajorAssumption,
    LogisticCostPerActivity,
    TotalLogisticCost,
    BargeLogisticMonitoring,
    LogisticCost3rdPartyCoal
  },
  data() {
    return {
      filters: {
        owner_id: null,
        route_name: null,
        month: null,
        year: this.moment().format('YYYY')
      },
      options: {
        owner: [],
        route: []
      }
    }
  },
  computed: {
    ...mapGetters({
      routes: 'Dashboard/routeOpt',
      owners: 'Dashboard/ownerOpt'
    })
  },
  mounted() {
    this.fetchOwners()
    this.fetchRoutes()
  },
  watch: {
    owners: {
      handler(val) {
        if (val) {
          this.options.owner = val.map(item => ({ text: item.owner_name, value: item.id }))
        }
      }
    },
    routes: {
      handler(val) {
        if (val) {
          this.options.route = val.map((route) => ({
            text: route,
            value: route
          }))
        }
      }
    }
  },
  methods: {
    resetFilters() {
      this.filters = {
        owner_id: null,
        route_name: null,
        month: null,
        year: this.moment().format('YYYY')
      }
    },
    async fetchCompanies() {
      try {
        await this.$store.dispatch('Companies/fetchCompanies', {
          is_master_data: true,
          type: 'TUG_OWNER',
          status: true,
          sort_dir: 'asc',
          sort_by: 'name',
          page: null,
          limit: null
        })
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch companies, please try again')
      }
    },
    async fetchOwners() {
      try {
        const payload = {
          month: this.filters.month ? parseInt(this.filters.month) : null,
          year: this.filters.year ? parseInt(this.filters.year) : null
        }
        await this.$store.dispatch('Dashboard/getOwnerOpt', payload)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch Owner, please try again')
      }
    },
    async fetchRoutes() {
      try {
        const payload = {
          month: this.filters.month ? parseInt(this.filters.month) : null,
          year: this.filters.year ? parseInt(this.filters.year) : null
        }
        await this.$store.dispatch('Dashboard/getRouteOpt', payload)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch Routes, please try again')
      }
    }
  }
}
</script>

<style lang="scss"  scoped>
.filter-container {
  @apply w-full p-3 mt-5 flex flex-row items-center bg-white rounded-lg;
}
</style>
